import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Radio, RadioGroup } from 'rsuite';
import { AVATAR_COLORS } from '@shared/static/avatars';
import { FormGroup } from '@shared/ui/forms/display';

export default function AvatarColorPicker({ control }) {
  const { t } = useTranslation();
  return (
    <FormGroup label={t('color')}>
      <Controller
        control={control}
        name="avatar.color"
        render={({ field }) => (
          <RadioGroup
            className="radio-colors-group"
            name="avatar-color"
            value={field.value}
            onChange={field.onChange}
          >
            {AVATAR_COLORS.map((color) => (
              <Radio key={color} value={color}>
                <div className="circle" style={{ color }} />
              </Radio>
            ))}
          </RadioGroup>
        )}
      />
    </FormGroup>
  );
}
